"use client"

import { ThemeProvider } from "next-themes"

export const AppThemeProvider = ({ children }: React.PropsWithChildren) => (
  <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
    {children}
  </ThemeProvider>
)
